import { render, staticRenderFns } from "./PodtList.vue?vue&type=template&id=2935e656&scoped=true&"
import script from "./PodtList.vue?vue&type=script&lang=js&"
export * from "./PodtList.vue?vue&type=script&lang=js&"
import style0 from "./PodtList.vue?vue&type=style&index=0&id=2935e656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935e656",
  null
  
)

export default component.exports